const AUTH_BASE = '/web/auth'
const CSRF_COOKIE = '__Secure-bff_csrf'
const CSRF_HEADER = 'X-Csrf-Token'

const getCsrfToken = (): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${CSRF_COOKIE}=([^;]*)`))
  return match?.[1]
}

const REFRESH_INTERVAL = 10 * 60 * 1000 // 10 minutes

let refreshTimer: ReturnType<typeof setInterval> | null = null

export const authService = {
  startAutoRefresh: () => {
    authService.stopAutoRefresh()
    refreshTimer = setInterval(async () => {
      try {
        await authService.refresh()
      } catch {
        authService.login()
      }
    }, REFRESH_INTERVAL)
  },

  stopAutoRefresh: () => {
    if (refreshTimer) {
      clearInterval(refreshTimer)
      refreshTimer = null
    }
  },

  login: (returnUrl = window.location.pathname) => {
    window.location.href = `${AUTH_BASE}/login?returnUrl=${encodeURIComponent(returnUrl)}`
  },

  refresh: async (): Promise<void> => {
    const headers: Record<string, string> = {}
    const csrf = getCsrfToken()
    if (csrf) {
      headers[CSRF_HEADER] = csrf
    }

    const response = await fetch(`${AUTH_BASE}/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers,
    })

    if (!response.ok) {
      throw new Error(`Auth refresh failed: ${response.status}`)
    }
  },

  logout: async (): Promise<void> => {
    const headers: Record<string, string> = {}
    const csrf = getCsrfToken()
    if (csrf) {
      headers[CSRF_HEADER] = csrf
    }

    const response = await fetch(`${AUTH_BASE}/logout`, {
      method: 'POST',
      credentials: 'include',
      headers,
    })

    if (!response.ok) {
      throw new Error(`Logout failed: ${response.status}`)
    }
  },
}
